import PropTypes from 'prop-types';

import { FaTimes } from 'react-icons/fa';

import './BookingHeader.css';

const BookingHeader = ({ children, iconColor, onClick, title, extraClass }) => {
    return (
        <div className={`ab-page-header ${extraClass}`}>
            {onClick && (
                <FaTimes
                    className="ab-page-closer"
                    size={25}
                    onClick={onClick}
                    color={iconColor}
                />
            )}
            {title && <div className="ab-page-title">{title}</div>}
            {children}
        </div>
    );
};

BookingHeader.propTypes = {
    children: PropTypes.node,
    iconColor: PropTypes.string,
    onClick: PropTypes.func,
    title: PropTypes.string,
    extraClass: PropTypes.string,
};

export default BookingHeader;
